import { FontSizes, FontWeights } from '@uifabric/styling';
import { FindRecipientStyleProps, FindRecipientStyles } from './FindRecipient.types';

export const getStyles = (props: FindRecipientStyleProps): FindRecipientStyles => {
    const { theme, isHighlighted } = props;
    const { palette } = theme;

    return {
        container: [
            {
                height: '48px',
                width: '300px',
                maxWidth: '100%',
                overflow: 'hidden',
                position: 'relative',
            },
            isHighlighted && {
                backgroundColor: palette.themeLighter,
            },
            [
                {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.neutralLighter,
                        },
                        ':hover .FindRecipient-maskRecipientButton': {
                            opacity: 1,
                        },
                    },
                },
                isHighlighted && {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.themeLight,
                        },
                    },
                },
            ],
        ],
        maskRecipientButton: [
            'FindRecipient-maskRecipientButton',
            {
                height: '48px',
                width: 'calc(15% - 12px)',
                position: 'absolute',
                top: 0,
                right: 0,
                opacity: 0,
            },
            [
                {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.neutralLight,
                        },
                    },
                },
                isHighlighted && {
                    selectors: {
                        'hover:': {
                            backgroundColor: palette.themeTertiary,
                        },
                    },
                },
            ],
        ],
        personaContainer: [
            {
                marginLeft: '12px',
                marginTop: '8px',
                display: 'inline-block',
                tableLayout: 'fixed',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '85%',
            },
        ],
        personaImage: [
            {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'middle',
                width: '32px',
            },
        ],
        personaText: [
            {
                paddingLeft: '12px',
                display: 'inline-block',
                verticalAlign: 'middle',
                width: '80%',
            },
        ],
        memberPersonaImage: [
            {
                position: 'relative',
                display: 'table-cell',
                verticalAlign: 'middle',
                width: '20px',
            },
        ],
        personaTextLine: [
            {
                width: '100%',
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        ],
        personaLineOne: [
            {
                fontSize: FontSizes.medium,
                fontWeight: FontWeights.regular,
                color: palette.neutralPrimary,
            },
        ],
        personaLineTwo: [
            {
                fontSize: FontSizes.small,
                fontWeight: FontWeights.regular,
                color: palette.neutralSecondary,
                textOverflow: 'ellipsis',
                position: 'relative',
                top: '-2px',
            },
        ],
        cancelIcon: [
            {
                fontSize: FontSizes.small,
                color: palette.neutralPrimary,
                position: 'relative',
                top: '18px',
                left: '10px',
            },
        ],
        linkedInIcon: [
            {
                fontSize: FontSizes.small,
                position: 'relative',
                color: '#106ebe', // Hard coded color because this is a brand icon
                verticalAlign: 'bottom',
                paddingLeft: '5px',
            },
        ],
    };
};
